import { createDraftSafeSelector } from '@reduxjs/toolkit';

import translationsApi from 'modules/translations/service';
import { getCustomerLanguage } from 'modules/selfServices/selectors';
import { getDealerCustomerLanguage } from 'modules/dealers/selectors';

import { getSelectedLanguage } from '.';

export const getLanguagesSelectors = translationsApi.endpoints.getLanguages.select();
export const getTranslationsSelectors = translationsApi.endpoints.getTranslationsByLanguage.select('getTranslations');
export const getAllLanguages = createDraftSafeSelector(getLanguagesSelectors, ({ data: languages }) => languages ?? []);

export const getLanguages = createDraftSafeSelector(
  getSelectedLanguage,
  getCustomerLanguage,
  getDealerCustomerLanguage,
  (...languages) => languages.filter(Boolean).map((lang) => lang.toLowerCase()),
);
